import AppRouter from './router';
import { Toaster } from '@/components/ui/sonner';
import { ServiceWorkerRegister } from '@/components/site/service-worker-register';

export default function App() {
  return (
    <>
      <ServiceWorkerRegister />
      <AppRouter />
      <Toaster />
    </>
  );
}
